import { Dialog } from '@headlessui/react';
import { NavLink } from 'react-router-dom';
import {
  BarChart3,
  Calendar,
  Building2,
  Settings,
  X,
  TrendingUp,
  SlidersHorizontal,
  History,
  HelpCircle,
} from 'lucide-react';

const navigationGroups = [
  {
    label: 'Workspace',
    items: [
      { name: 'Overview', href: '/', icon: BarChart3 },
      { name: 'Rate calendar', href: '/calendar', icon: Calendar },
      { name: 'Pricing', href: '/pricing', icon: SlidersHorizontal },
      { name: 'Analytics', href: '/analytics', icon: TrendingUp },
      { name: 'Change history', href: '/audit', icon: History },
    ],
  },
  {
    label: 'Management',
    items: [
      { name: 'Properties & rooms', href: '/properties', icon: Building2 },
      { name: 'Connections & settings', href: '/settings', icon: Settings },
      { name: 'Help', href: '/help', icon: HelpCircle },
    ],
  },
];
export default function Sidebar({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const content = (
    <>
      <div className="flex h-16 shrink-0 items-center gap-3 border-b border-slate-200 dark:border-slate-800 px-5">
        <TrendingUp className="h-7 w-7 text-blue-600" aria-hidden="true" />
        <div>
          <p className="font-bold text-lg">SmartRate</p>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Revenue management
          </p>
        </div>
      </div>
      <nav
        aria-label="Main navigation"
        className="flex-1 overflow-y-auto p-3 space-y-6"
      >
        {navigationGroups.map((group) => (
          <div key={group.label}>
            <p className="px-3 mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              {group.label}
            </p>
            <ul className="space-y-1">
              {group.items.map((item) => (
                <li key={item.href}>
                  <NavLink
                    to={item.href}
                    end={item.href === '/'}
                    onClick={onClose}
                    className={({ isActive }) =>
                      `flex min-h-11 items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium ${isActive ? 'bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300' : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800'}`
                    }
                  >
                    <item.icon
                      className="h-5 w-5 shrink-0"
                      aria-hidden="true"
                    />
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </>
  );
  return (
    <>
      <aside className="hidden md:flex fixed inset-y-0 left-0 z-40 w-60 flex-col border-r border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
        {content}
      </aside>
      <Dialog
        open={isOpen}
        onClose={onClose}
        className="relative z-[70] md:hidden"
      >
        <div className="fixed inset-0 bg-slate-950/50" aria-hidden="true" />
        <Dialog.Panel className="fixed inset-y-0 left-0 flex w-[min(20rem,90vw)] flex-col bg-white dark:bg-slate-900">
          <Dialog.Title className="sr-only">Navigation</Dialog.Title>
          <button
            onClick={onClose}
            aria-label="Close navigation"
            className="absolute right-2 top-2 p-3"
          >
            <X className="h-5 w-5" />
          </button>
          {content}
        </Dialog.Panel>
      </Dialog>
    </>
  );
}
